import type { Cliente } from '../db/tipos'

// Campos essenciais do cliente (necessários, entre outras coisas, para emissão de nota).
export const CAMPOS_OBRIGATORIOS_CLIENTE = ['razao_social', 'cnpj_cpf', 'ddd', 'telefone'] as const
export type CampoObrigatorioCliente = (typeof CAMPOS_OBRIGATORIOS_CLIENTE)[number]

export const ROTULO_CAMPO_CLIENTE: Record<CampoObrigatorioCliente, string> = {
  razao_social: 'Razão Social',
  cnpj_cpf: 'CNPJ/CPF',
  ddd: 'DDD',
  telefone: 'Telefone',
}

// Quais obrigatórios estão faltando (vazio = cadastro completo).
// ddd/telefone vivem em contatos[]: "tem" = algum contato com o campo preenchido.
export function camposFaltandoCliente(cliente: Cliente): CampoObrigatorioCliente[] {
  const faltando: CampoObrigatorioCliente[] = []
  if (!cliente.razao_social?.trim()) faltando.push('razao_social')
  if (!cliente.cnpj_cpf?.trim()) faltando.push('cnpj_cpf')
  if (!cliente.contatos.some((c) => c.ddd?.trim())) faltando.push('ddd')
  if (!cliente.contatos.some((c) => c.telefone?.trim())) faltando.push('telefone')
  return faltando
}

export function cadastroIncompleto(cliente: Cliente): boolean {
  return camposFaltandoCliente(cliente).length > 0
}
